// removed by extract-text-webpack-plugin
module.exports = {"glossaryPage":"glossaryPage--3ENZ7"};